import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';
import { createJpdExperience } from '../../utils/experience/main.tsx';
import type { JPDExperience } from '../../utils/experience/types.tsx';

export const loadIssuesRestBatched: JPDExperience = createJpdExperience(
	new UFOExperience('jpd.issues.load.rest-batched', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadIssueRest = createJpdExperience(
	new UFOExperience('jpd.issue.load.rest', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadIssuesJpdApi = createJpdExperience(
	new UFOExperience('jpd.issues.load.jpd-api', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadIssueJpdApi = createJpdExperience(
	new UFOExperience('jpd.issue.load.jpd-api', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadIssuesRanksRestBatched = createJpdExperience(
	new UFOExperience('jpd.issues.ranks.load.rest-batched', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadIssuesRanksJpdApi = createJpdExperience(
	new UFOExperience('jpd.issues.ranks.load.jpd-api', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);
export const rankIssue = createJpdExperience(
	new UFOExperience('jpd.issue.rank', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadIssuePickerIssuesRest = createJpdExperience(
	new UFOExperience('jpd.issue-picker.load', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const globalJpdIssueCreate = createJpdExperience(
	new UFOExperience('jpd.global.jpd.create-issue', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);
